import { render } from "./EventsStart.vue?vue&type=template&id=82fe8316&scoped=true&ts=true"
import script from "./EventsStart.vue?vue&type=script&lang=ts"
export * from "./EventsStart.vue?vue&type=script&lang=ts"

import "./EventsStart.vue?vue&type=style&index=0&id=82fe8316&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fe8316"]])

export default __exports__